// This file was generated with `pnpm run build:icons`. Don’t edit directly.
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';
import { IconV2 } from 'components/common/IconV2/IconV2';

const CaretLeftIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" d="M19.936 8.032 12.065 16l7.87 7.968" />
  </IconV2>
);

export default CaretLeftIcon;
